import React from 'react';
import { View, Text, StyleSheet } from 'react-native-web';

const StarRating = ({ rating, label }) => {
    const clampedRating = Math.max(0, Math.min(5, rating || 0));
    
    const renderStar = (position) => {
        const fillPercentage = Math.max(0, Math.min(100, (clampedRating - (position - 1)) * 100));
        
        return (
            <View key={`star-${position}`} style={styles.starContainer}>
                <Text style={[styles.star, styles.emptyStar]}>☆</Text>
                <View style={[styles.starFill, { width: `${fillPercentage}%` }]}>
                    <Text style={[styles.star, styles.filledStar]}>★</Text>
                </View>
            </View>
        );
    };

    return (
        <View style={styles.container}>
            <Text style={styles.label}>{label}</Text>
            <View style={styles.starsContainer}>
                {[1, 2, 3, 4, 5].map(position => renderStar(position))}
            </View>
            <Text style={styles.ratingText}>{clampedRating.toFixed(1)}</Text>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 15,
    },
    label: {
        fontSize: 12,
        color: '#737373',
        marginRight: 5,
    },
    starsContainer: {
        flexDirection: 'row',
        marginRight: 5,
    },
    starContainer: {
        position: 'relative',
        width: 14,
        height: 14,
        marginRight: 2,
    },
    star: {
        fontSize: 14,
        position: 'absolute',
        top: 0,
        left: 0,
        width: 14,
        height: 14,
        textAlign: 'center',
        lineHeight: 14,
    },
    starFill: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: 14,
        overflow: 'hidden',
    },
    emptyStar: {
        color: '#b8cbf5',
    },
    filledStar: {
        color: '#396de0',
    },
    ratingText: {
        fontSize: 12,
        color: '#737373',
    },
});

export default StarRating; 